import { memo } from "react";
import { bool, string } from "prop-types";
import { Grid } from "@material-ui/core";
import { DragIndicator } from "@material-ui/icons";
import useStyle from "./DragHandleCell.style";
import useCellStyle from "../../../../styles/CommonTableCellStyles.style";
import classnames from "classnames";

export const DragHandleCell = memo(({
  isHeader,
  displayHandle,
  presetClass,
}) => {
  const classes = useStyle();
  const cellClasses = useCellStyle();

  return (
    <Grid
      item
      container
      role="rowitem"
      alignItems="flex-start"
      className={classnames(
        "pr-2 dragHandleContainer noExpand",
        "preset-noedit",
        presetClass,
        classes.dragHandleCell,
        isHeader && cellClasses.headCell,
      )}
    >
      <Grid
        item container
        alignItems="center"
        wrap="nowrap"
        className={classnames(!isHeader && cellClasses.cellInner)}
      >
        {
          displayHandle &&
          <DragIndicator
            className={classnames(
              "dragHandle hoverIcon opq",
              classes.handle,
            )}
          />
        }
      </Grid>
    </Grid>
  );
});

DragHandleCell.propTypes = {
  isHeader: bool,
  displayHandle: bool,
  presetClass: string,
};
